/**
 * Keep JumpToPage button props in sync: PageList and buttonValue must match.
 * Runtime (ROIPage) reads buttonValue; Puck editor fields use PageList.
 */

export function syncSingleButtonProps(props) {
  if (!props || typeof props !== "object" || props.buttonAction !== "JumpToPage") {
    return props;
  }

  const pageId = props.PageList || props.buttonValue || "";
  if (!pageId) {
    return props;
  }

  return {
    ...props,
    PageList: pageId,
    buttonValue: pageId,
  };
}

function syncNestedButtonProps(props) {
  if (!props || typeof props !== "object" || Array.isArray(props)) {
    return props;
  }

  const synced = { ...props };

  Object.keys(synced).forEach((key) => {
    const value = synced[key];

    if (value && typeof value === "object" && !Array.isArray(value)) {
      if (Object.prototype.hasOwnProperty.call(value, "buttonAction")) {
        synced[key] = syncSingleButtonProps(value);
      }
      return;
    }

    if (Array.isArray(value)) {
      synced[key] = value.map((item) =>
        item &&
        typeof item === "object" &&
        Object.prototype.hasOwnProperty.call(item, "buttonAction")
          ? syncSingleButtonProps(item)
          : item
      );
    }
  });

  return synced;
}

function syncComponent(component) {
  if (!component?.props) {
    return component;
  }

  let props =
    component.type === "Button"
      ? syncSingleButtonProps(component.props)
      : { ...component.props };

  props = syncNestedButtonProps(props);

  return { ...component, props };
}

export function syncStructureJumpToPageButtons(structure) {
  if (!structure || typeof structure !== "object") {
    return structure;
  }

  const synced = { ...structure };

  if (Array.isArray(synced.content)) {
    synced.content = synced.content.map(syncComponent);
  }

  if (synced.zones && typeof synced.zones === "object") {
    synced.zones = Object.fromEntries(
      Object.entries(synced.zones).map(([zoneKey, components]) => [
        zoneKey,
        Array.isArray(components) ? components.map(syncComponent) : components,
      ])
    );
  }

  return synced;
}
